// General Page Section
export const HOME_PAGE = '/';
export const AGENTS_PAGE = '/agents';

// Listing Single Page Section
export const LISTING_POSTS_PAGE = '/listing';
export const SINGLE_POST_PAGE = '/post';

// Agent Profile Page Section
export const AGENT_PROFILE_PAGE = '/profile';
export const AGENT_PROFILE_FAVORITE = 'favorite-post';
export const AGENT_PROFILE_CONTACT = 'contact';
export const AGENT_ACCOUNT_SETTINGS_PAGE = '/account-settings';
export const AGENT_PROFILE_EDIT_PAGE = 'edit';
export const AGENT_IMAGE_EDIT_PAGE = 'change-image';
export const AGENT_PASSWORD_CHANGE_PAGE = 'change-password';
export const AGENT_PROFILE_DELETE = '/delete';

// Other Pages
export const PRICING_PLAN_PAGE = '/pricing-plan';
export const PRIVACY_PAGE = '/privacy';
export const ADD_HOTEL_PAGE = '/add-hotel';
export const CHAT_PAGE = '/chat';
export const HOST_MESSAGES_PAGE = '/messages';

// Login / Registration Page
export const LOGIN_PAGE = '/sign-in';
export const REGISTRATION_PAGE = '/sign-up';
export const CHANGE_PASSWORD_PAGE = '/change-password';
export const FORGET_PASSWORD_PAGE = '/forget-password';
export const AFFILIATES_PAGE = '/host/affiliates';
export const LEADS_DASHBOARD_PAGE = '/admin/leads';
export const PROPERTY_SOURCE_PAGE = '/admin/property-source';

export const TAG_OPTIONS = ['Comfort', 'Premium', 'Luxury'];

export const IMAGE_CATEGORY_OPTIONS = {
  livingRoom: 'Living Room',
  drawingRoom: 'Drawing Room',
  corridor: 'Corridor',
  commonArea: 'Common Area',
  sharedArea: 'Shared Area',
  bedroom: 'Bedroom',
  bedroom1: 'Bedroom 1',
  bedroom2: 'Bedroom 2',
  bedroom3: 'Bedroom 3',
  bedroom4: 'Bedroom 4',
  bedroom5: 'Bedroom 5',
  bedroom6: 'Bedroom 6',
  bedroom7: 'Bedroom 7',
  bedroom8: 'Bedroom 8',
  bathroom1: 'Bathroom 1',
  bathroom2: 'Bathroom 2',
  bathroom3: 'Bathroom 3',
  bathroom4: 'Bathroom 4',
  bathroom5: 'Bathroom 5',
  bathroom6: 'Bathroom 6',
  bathroom7: 'Bathroom 7',
  bathroom8: 'Bathroom 8',
  external: 'External',
  poolview: 'Pool View',
  bathroom: 'Bathroom',
  sharedBathroom: 'Shared Bathroom',
  kidsPlayArea: 'Kids Play area',
  kitchen: 'Kitchen',
  diningArea: 'Dining Area',
  sharedKitchen: 'Shared Kitchen',
  balcony: 'Balcony',
  terrace: 'Terrace',
  verandahPatio: 'Verandah/Patio',
  privatePool: 'Private Pool',
  commonPool: 'Common Pool',
  poolDeck: 'Pool Deck',
  exteriorPropertyView: 'Exterior Property View',
  privateGarden: 'Private Garden',
  commonGarden: 'Common Garden',
  dedicatedWorkspace: 'Dedicated Workspace',
  parking: 'Parking',
  garage: 'Garage',
  gym: 'Gym',
  library: 'Library',
  jacuzzi: 'Jacuzzi',
  bathTub: 'Bath tub',
  propertySurrounding: 'Property Surrounding',
  viewFromProperty: 'View from Property',
  additionalPhotos: 'Additional photos',
  other: 'Other',
};
